export default __webpack_public_path__ + "static/media/Login.163f9c29.jpg";